// extracted by mini-css-extract-plugin
export default {"addNameInput":"EmailForm_addNameInput__0067t"};